/** Tenant-only opt-in. Missing/unreadable rows retain the legacy publication path. */
export const ROSTER_GUIDED_PUBLISH_FLAG = 'roster_guided_publish_v1';
export function isTenantScopedRosterGuidedPublishFlag(key: string | null | undefined): boolean {
  return key === ROSTER_GUIDED_PUBLISH_FLAG;
}
